import { ApiUrl } from "../../../Constants/Api";
import {
  REQUEST_METHOD,
  WebService,
} from "../../WebServiceManager/RequestService";
import EventRequestBody from "./EventRequestBody";

export default class EventService {
    
  request = new EventRequestBody();
  static shared = new EventService();

  eventsListRequest = (payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.getAllEvents(payload.page, payload.size,payload.eventType,payload.month),
          this.request.eventsListRequest( REQUEST_METHOD.GET)
        )
        .then((response) => {
          resolve(response);
        }) 
        .catch((error) => {
          reject(error);
        });
    });
  } 

  eventsNotificationsListRequest = (payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.getAllEventsNotifications(payload),
          this.request.eventsNotificationsListRequest( REQUEST_METHOD.GET)
        )
        .then((response) => {
          resolve(response);
        }) 
        .catch((error) => {
          reject(error);
        });
    });
  }

  workAnniversaryWishesRequest = (payload) => {
    const { userId, ...requestData } = payload;
    if (!userId) { 
      return Promise.reject(new Error("User ID is required"));
    }
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.sendWorkAnniversaryWishes(userId),
          this.request.workAnniversaryWishesRequest(REQUEST_METHOD.POST, requestData)
        )
        .then((response) => {
          resolve(response);
        }) 
        .catch((error) => {
          reject(error);
        });
    });
  }

  birthdayWishesRequest = (payload) => {
    const { userId, ...requestData } = payload;
    if (!userId) { 
      return Promise.reject(new Error("User ID is required"));
    }
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.sendBirthdayWishes(userId),
          this.request.birthdayWishesRequest( REQUEST_METHOD.POST, requestData)
        )
        .then((response) => {
          resolve(response);
        }) 
        .catch((error) => {
          reject(error);
        });
    });
  }

}